import { useEffect, useState } from "react";
import { Building2, HardHat, Home } from "lucide-react";

import { Button } from "./ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";

const TIPOS = [
  {
    id: "vivienda",
    icon: Home,
    titulo: "Vivienda",
    descripcion: "Piso, casa, unifamiliar",
  },
  {
    id: "local_comercial",
    icon: Building2,
    titulo: "Local comercial",
    descripcion: "Oficina, tienda, restaurante",
  },
  {
    id: "rehabilitacion_parcial",
    icon: HardHat,
    titulo: "Rehabilitación parcial",
    descripcion: "Fachada, cubierta, instalación",
  },
];

export default function ProyectoIntegralTipoModal({
  open,
  onClose,
  onContinuar,
  tipoInicial,
}) {
  const [tipo, setTipo] = useState(tipoInicial ?? null);

  useEffect(() => {
    if (open) setTipo(tipoInicial ?? null);
  }, [open, tipoInicial]);

  const handleContinuar = () => {
    if (!tipo) return;
    onContinuar?.(tipo);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose?.()}>
      <DialogContent
        className="max-w-2xl"
        data-testid="proyecto-integral-tipo-modal"
      >
        <DialogHeader>
          <div className="flex items-center gap-2">
            <span className="inline-flex items-center justify-center w-8 h-8 rounded-md bg-blue-50 text-blue-600">
              <Building2 className="w-4 h-4" />
            </span>
            <DialogTitle className="font-display font-bold text-lg">
              Proyecto integral
            </DialogTitle>
          </div>
          <DialogDescription className="text-sm text-slate-500">
            Describe la reforma completa. La IA dividirá por zonas y revisará el
            resultado.
          </DialogDescription>
        </DialogHeader>

        <div>
          <div className="text-xs uppercase tracking-widest font-bold text-slate-500 mb-2">
            ¿Qué tipo de proyecto es?
          </div>
          <div className="grid grid-cols-3 gap-3">
            {TIPOS.map((t) => {
              const Icon = t.icon;
              const active = tipo === t.id;
              return (
                <button
                  key={t.id}
                  type="button"
                  onClick={() => setTipo(t.id)}
                  data-testid={`pi-tipo-${t.id}`}
                  className={`text-center p-4 rounded-md border transition-all flex flex-col items-center gap-1 ${
                    active
                      ? "border-blue-600 bg-blue-50/60 ring-2 ring-blue-600 text-blue-700"
                      : "border-slate-200 hover:border-slate-300 text-slate-700"
                  }`}
                >
                  <Icon className="w-6 h-6 mb-1" />
                  <div className="font-display font-bold text-sm">{t.titulo}</div>
                  <div className="text-[11px] text-slate-500 leading-snug">
                    {t.descripcion}
                  </div>
                </button>
              );
            })}
          </div>
        </div>

        <div className="flex justify-end gap-2 mt-2">
          <Button
            variant="outline"
            onClick={() => onClose?.()}
            data-testid="pi-tipo-cancelar"
            className="border-slate-300"
          >
            Cancelar
          </Button>
          <Button
            onClick={handleContinuar}
            disabled={!tipo}
            data-testid="pi-tipo-continuar"
            className="bg-blue-600 hover:bg-blue-700"
          >
            Continuar
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
